import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EComfortAndApplianceScoreActionTypes {
  SetRating = 'NEW_REVIEW/COMFORT_AND_APPLIANCE/SET',
}

type TSetComfortAndApplianceScore = ITypedReduxAction<EComfortAndApplianceScoreActionTypes.SetRating, number>;

export const setComfortAndApplianceScore: (rating: number) => TSetComfortAndApplianceScore = actionGenerator<
  EComfortAndApplianceScoreActionTypes.SetRating,
  number
>(EComfortAndApplianceScoreActionTypes.SetRating);

export type TComfortAndApplianceScore = TSetComfortAndApplianceScore;
